<template>
    <div class="check">
        <div v-for="(item, index) in textList" :class="index === selectIndex ? 'action' : ''" @click="press(index)">{{item}}</div>
    </div>
</template>

<script>
    export default {
        name: 'Check',
        data() {
            return {
                checkList: ['1','2','3'],
                textList:['好','一般','差'],
                selectIndex: 0
            }
        },
        methods: {
            press(index) {
                this.selectIndex = index
                this.$emit('change',this.checkList[this.selectIndex])
            }
        }
    }
</script>

<style scoped lang="scss">
    .check{
        display: flex;
        align-items: center;
        div{
            width: 120px;
            height: 40px;
            border-radius: 20px;
            border: 1px solid #DCDCDC;
            background: #fff;
            color: #858585;
            font-size: 24px;
            margin-right: 40px;
            text-align: center;
            line-height: 40px;
        }
        span{
            color: $THEME-COLOR;
            font-size: 28px;
        }
        .action{
            color: #fff;
            background: $THEME-COLOR;
            border-color: rgba(0,0,0,0);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/check/check.vue